import React, { useEffect, useMemo } from 'react';

const SelectOption = ({ selectedOptions, option, variants, onChange, classes = '' }) => {
  const optionId = `product-option-${option.name}`;

  // Find the selected value for this option
  const selectedOption = selectedOptions.find((o) => o.name === option.name);
  const selectedValue = selectedOption?.value || '';

  // Compute available values for this option
  const availableValues = useMemo(() => {
    // For each value, check if any variant with this value combination is available
    return option.values.filter((value) => {
      const simulatedOptions = selectedOptions.map((o) => (o.name === option.name ? { name: option.name, value } : o));
      const matchingVariant = variants.find(
        (v) => JSON.stringify(v.selectedOptions) === JSON.stringify(simulatedOptions),
      );
      return matchingVariant?.availableForSale && matchingVariant.inventoryQuantity > 0;
    });
  }, [option, variants, selectedOptions]);

  // Auto-select next available value if current selection becomes unavailable
  useEffect(() => {
    if (!availableValues.includes(selectedValue) && availableValues.length > 0) {
      onChange(option, availableValues[0]);
    }
  }, [availableValues, selectedValue, onChange, option]);

  return (
    <div className={classes}>
      <label
        htmlFor={optionId}
        className="body-2 mb-2 block"
      >
        {option.name}
      </label>
      <select
        id={optionId}
        name={optionId}
        className="mt-1 block w-full border-gray-300 py-2 pl-3 pr-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
        value={selectedValue}
        onChange={(e) => onChange(option, e.target.value)}
        data-option-name={option.name}
      >
        {option.values.map((value) => {
          const simulatedOptions = selectedOptions.map((o) =>
            o.name === option.name ? { name: option.name, value } : o,
          );
          const matchingVariant = variants.find(
            (v) => JSON.stringify(v.selectedOptions) === JSON.stringify(simulatedOptions),
          );
          const isAvailable = matchingVariant?.availableForSale && matchingVariant.inventoryQuantity > 0;

          return (
            <option
              key={`${optionId}-${value}`}
              value={value}
              disabled={!isAvailable}
            >
              {value} {!isAvailable ? ' (Out of stock)' : ''}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default SelectOption;
